import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from '../../../shared/services/courier.service';
import { GetCourierCarListResponse } from '../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';

@Component({
  templateUrl: 'visual-damage-pick-type.component.html',
  styleUrls: ['./visual-damage-pick-type.component.scss']
})
export class VisualDamagePickTypeComponent implements OnInit {

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router
  ) {}

  ngOnInit() {}

  pickVisualDamage() {
    this.activeUserLocalDataService.visualDamageType = 'd';
    const activeVoucher = this.activeUserLocalDataService.getActiveCourierVoucher() || this.activeUserLocalDataService.activeServiceVoucher;
    if (activeVoucher?.isServiceVoucher) {
      this.router.navigate(['/service-visual-damage-action-pick']);
    } else {
      this.router.navigate(['/visual-damage-action-pick']);
    }
  }

  pickAccident() {
    this.activeUserLocalDataService.visualDamageType = 'c';
    const activeVoucher = this.activeUserLocalDataService.getActiveCourierVoucher() || this.activeUserLocalDataService.activeServiceVoucher;
    if (activeVoucher?.isServiceVoucher) {
      this.router.navigate(['/service-visual-damage-action-pick']);
    } else {
      this.router.navigate(['/visual-damage-action-pick']);
    }
  }

  backClick() {
    const activeVoucher = this.activeUserLocalDataService.getActiveCourierVoucher() || this.activeUserLocalDataService.activeServiceVoucher;
    if (activeVoucher?.isServiceVoucher) {
      this.router.navigate(['/service-voucher']);
    } else {
      this.router.navigate(['/voucher']);
    }
  }
}